// Module
var code = "<flow-model-import close=\"ctrl.close\"></flow-model-import> ";
// Exports
export default code;